export const getSalesforceRep = (state) => state.applicationConfig.isSalesforceRep || false;
export const getApplicationApiKey = (state) => state.applicationConfig.apikey || {};
export const getIsMobileParam = (state) => state.applicationConfig.isMobileParam || false;
